import {
  ApplicationsIcon,
  DashboardIcon,
  DocumentIcon,
  LogoutIcon,
  ProfileIcon,
  PropertyIcon,
  SupportIcon,
} from "assets/images";

const navLinks = [
  {
    name: "dashboard",
    url: "/dashboard",
    icon: <DashboardIcon />,
    activeIcon: <DashboardIcon color="#0072CE" />,
  },
  {
    name: "profile",
    url: "/profile",
    icon: <ProfileIcon />,
    activeIcon: <ProfileIcon color="#0072CE" />,
  },
  {
    name: "applications",
    url: "/applications",
    icon: <ApplicationsIcon />,
    activeIcon: <ApplicationsIcon color="#0072CE" />,
  },
  {
    name: "documents",
    url: "/documents",
    icon: <DocumentIcon />,
    activeIcon: <DocumentIcon color="#0072CE" />,
  },
  // {
  //   name: "mortgage calc.",
  //   url: "/mortgage-calc",
  //   icon: <DashboardIcon />,
  //   activeIcon: <DocumentIcon color="#0a2240" />,
  // },
  // {
  //   name: "property listing",
  //   url: "/property-listing",
  //   icon: <PropertyIcon />,
  //   activeIcon: <PropertyIcon color="#0a2240" />,
  // },
  {
    name: "Contact Us",
    url: "/contact-us",
    icon: <SupportIcon />,
    activeIcon: <SupportIcon color="#0072CE" />,
  },
];

export default navLinks;
